import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material';

// MUI
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { alpha } from '@mui/material/styles';

// Icons
import CogIcon from '@mui/icons-material/Settings';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { getSubscriptionStatusBegin } from '../../redux/actions/billingActions';

// Model
import { ApplicationState } from '../../interface/ApplicationState';

// Misc
import moment from 'moment';

// Custom
import { ManageSubscriptionModal } from './ManageSubscriptionModal';
import { SubscriptionModal } from './SubscriptionModal';
import { SubscriptionSkeleton } from './SubscriptionSkeleton';

export const SubscriptionSection = () =>
{
  const dispatch = useDispatch()

  // Redux State
  const user = useSelector((state: ApplicationState) => state.userStore.user)
  const subscriptionStatus = useSelector((state: ApplicationState) => state.billing.subscriptionStatus);
  const isGettingSubscriptions = useSelector((state: ApplicationState) => state.billing.isGettingSubscriptions);
  const subscriptionsError = useSelector((state: ApplicationState) => state.billing.subscriptionsError);

  // Local State
  const [ openModal, setOpenModal ] = useState(false)
  const [ openManageModal, setOpenManageModal ] = useState(false)

  const theme = useTheme()
  useEffect(() => {

    dispatch(getSubscriptionStatusBegin())

  }, [])


  const getSubscriptionStatus = () =>
  {
    try
    {
      // @ts-ignore
      if(subscriptionsError && subscriptionsError.message.response.data.error) return subscriptionsError.message.response.data.error
      if(subscriptionStatus?.isActive && subscriptionStatus?.mode === "admin") return "Active (Admin User)"
      if(subscriptionStatus?.isActive && subscriptionStatus?.mode === "paid") return "Active (Paid membership)"
      if(subscriptionStatus?.isActive && subscriptionStatus?.mode === "trial") return "Active (Free full feature trial, includes webapp, no ads, 10 trading pairs) Reverts to free mode after trial period (Ads, no webapp and only 1 trading pair)"
      if(!subscriptionStatus?.isActive && subscriptionStatus?.mode === "free") return "Active (Free) - includes ads, no webapp access and only 1 trading pair"
      return "Inactive"
    }
    catch(error)
    {
      return "Unknown"
    }
  }

  const handleCloseModal = () =>
  {
    setOpenModal(false)
    dispatch(getSubscriptionStatusBegin())

  }

  const handleCloseSubscriptionModal = () =>
  {
    setOpenManageModal(false)
    dispatch(getSubscriptionStatusBegin())
  }

  return(
    <Card sx={localStyles.card(theme)} >

    { isGettingSubscriptions ? <SubscriptionSkeleton /> :
    <>
      <Stack spacing={1.5}>
        <Grid item>
          <Typography variant="body2" sx={localStyles.copy(theme)}>Subscription Status</Typography>
          <Typography variant="h6">{getSubscriptionStatus()}</Typography>
        </Grid>


        { subscriptionStatus?.isActive && subscriptionStatus.mode === "paid" && <> 
          <Stack direction={{ xs: "column", md: "row" }} spacing={1} useFlexGap>
            <Chip label={`Last Payment ${moment(subscriptionStatus.lastBill).format('ll')} (${moment(subscriptionStatus.lastBill).fromNow()})`} sx={localStyles.chip(theme)} />
            <Chip label={`Next Payment ${moment(subscriptionStatus.nextBill).format('ll')} (${moment(subscriptionStatus.nextBill).fromNow()})`} sx={localStyles.chip(theme)} />
          </Stack>
        </>}

        { subscriptionStatus?.mode !== "paid" && <Button onClick={() => setOpenModal(true)} startIcon={<CogIcon />} variant="contained" sx={localStyles.button}>Setup Subscription</Button> }
        {/* // Allow paid users to manage their membership */}
        { subscriptionStatus?.isActive && subscriptionStatus?.mode === "paid" && <Button onClick={() => setOpenManageModal(true)} startIcon={<CogIcon />} variant="contained" sx={localStyles.button}>Manage Subscription</Button> }
      </Stack>
      </>
  }

    { openModal && <SubscriptionModal open={openModal} handleClose={handleCloseModal} user={user}/> }
    <ManageSubscriptionModal open={openManageModal} handleClose={handleCloseSubscriptionModal} user={user}/>

      
    </Card>
  )
}

const localStyles = {
  card: (theme: any) => ({
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.74),
    borderRadius: "16px",
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.55)}`,
    padding: 2.5,
    boxShadow: "none",
  }),
  copy: (theme: any) => ({
    color: alpha(theme.palette.text.primary, 0.62),
  }),
  chip: (theme: any) => ({
    justifyContent: "flex-start",
    borderRadius: "12px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.66),
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.45)}`,
  }),
  button: {
    width: "fit-content",
    borderRadius: "12px",
    boxShadow: "none",
  },
}
